function AwardsControl() {}

AwardsControl.DoNotPictures = 0;

AwardsControl.HidePictures = function(e) {
    AwardsControl.DoNotPictures = 1;
    AwardsControl.Update();
    $("#btnHidePictures").hide();
    $("#btnShowPictures").show();
    return false;
}

AwardsControl.ShowPictures = function(e) {
    AwardsControl.DoNotPictures = 0;
    AwardsControl.Update();

    $("#btnHidePictures").show();
    $("#btnShowPictures").hide();
    return false;
}

AwardsControl.OnDataReceived = function(data) {
    $("#awardsContainer").html(data);
}

AwardsControl.Update = function() {
    $("#donotpictures").val(AwardsControl.DoNotPictures);
    $("#awardsLoading").show();
    $("#awardsContainer").hide();

    var data = $('#awardsFilterForm').serializeArray();

    $.post('/legado/premios/getAwards', data,
            AwardsControl.OnDataReceived, 'html')
        .fail(function() {
            AwardsControl.OnDataReceived("error");
        })
        .always(function() {
            $("#awardsLoading").hide();
            $("#awardsContainer").show();
        });
}

$(document).ready(function() {
    AwardsControl.ShowPictures();

    $("#year").change(function() {
        AwardsControl.Update();
    });

    $("#awardKindNational").change(function() {
        AwardsControl.Update();
    });

    $("#awardKindInternational").change(function() {
        AwardsControl.Update();
    });

    $("#awardKindAll").change(function() {
        AwardsControl.Update();
    });

    $("#btnShowPictures").click(function() {
        AwardsControl.ShowPictures();
    });

    $("#btnHidePictures").click(function() {
        AwardsControl.HidePictures();
    });
});